export default __webpack_public_path__ + "static/media/TIECON-template.ba6af165.png";